export default "__VITE_ASSET__gakrK0d___"